import React from "react";
import '../styles.scss'

export const SearchResult = ({text}) => (
  <div className="search-result-text">{text}</div>
)

